<template>
  <div class="row clearfix">
    <div class="body">
      <!-- <div class="col-lg-12 col-md-12 col-sm-12" > -->

      <!-- <p>필드를 추가하세요.</p> -->

      <!-- <i class="zmdi zmdi-plus"></i>
            <button class="btn btn-default" type="button" @click="setComponent(0)">필드 추가</button>
            <button class="btn btn-default" type="button" @click="toDynamic" >다이나믹 필드 추가</button>
            <button class="btn btn-default"  type="button" @click="toLineGroup" >Line Item Group 추가</button>
            
        </div> -->

      <!-- <div class="row clearfix"> -->

      <div class="col-lg-12 col-md-6 col-sm-6" v-if="addBox">
        <div class="card">
          <div class="body">
            <div class="content">
              <div class="text mb-2 text-uppercase"><b>추가</b></div>
              <button
                class="btn btn-default"
                type="button"
                @click="setComponent(0)"
              >
                필드</button
              >&nbsp;
<!--              <button-->
<!--                class="btn btn-default"-->
<!--                type="button"-->
<!--                @click="toDynamicMain"-->
<!--              >-->
<!--                다이나믹 필드</button-->
<!--              >&nbsp;-->
<!--              <button-->
<!--                class="btn btn-default"-->
<!--                type="button"-->
<!--                @click="toLineGroupMain"-->
<!--              >-->
<!--                아이템그룹-->
<!--              </button>-->
<!--               <h4 class="number mb-0">3,251 <span class="font-12 text-muted"><i class="fa fa-level-up"></i> 13%</span></h4> -->
<!--               <small class="text-muted">Analytics for last week</small> -->
            </div>
          </div>
        </div>
      </div>

      <!-- </div> -->

      <div class="col-lg-12 col-md-12 col-sm-12" v-if="toForm">
        <router-view
          v-bind:is="whichComp"
          v-bind:typeData="typeOfBtn"
          @cancelingFormet="cancelAlert"
        />
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12" v-if="containTable">
      <!-- <button class="btn btn-default" type="button" @click="checkTyper">추가</button> -->
      <div class="body">
        <div class="table-responsive" style="text-align: center">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>타입</th>
                <th>키</th>
                <th>라벨</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(input, index) in inputLists" :key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td style="text-align: center">
                  {{ checkInputType(input.checkType) }}
                </td>
                <td>{{ removeEmojy(input.keys) }}</td>
                <td>{{ removeEmojy(input.label) }}</td>
                <td>
                  <a href="javascript:void(0);" @click="editPage(index)"
                    >수정</a
                  >
                  &nbsp;&nbsp;&nbsp;
                  <a href="javascript:void(0);" @click="deletePage(index)"
                    >삭제</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Urls from "@/common/urls";
// import Apiroot from "@/common/apiroot";

export default {
  props: ["toMain"],
  components: {
    DevActionInputFormField: () =>
      import("@/views/dev/action/DevActionInputFormField"),
    DevCodeMode: () => import("@/views/dev/tools/DevCodeMode"),
    DevActionLineItemGroup: () =>
      import("@/views/dev/action/DevActionLineItemGroup"),
  },
  methods: {
    setComponent(num) {
      this.inputTopBtns = !this.inputTopBtns;
      this.typeOfBtn = "field";
      this.addBox = !this.addBox;

      console.log(this.inputLists);

      this.$store.state.devStore.reMenu = this.inputLists.length;

      if (num == 0) {
        this.whichComp = "DevActionInputFormField";

        this.toForm = true;
        this.containTable = false;
      } else if (num == 1) {
        this.whichComp = "DevCodeMode";
      } else if (num == 2) {
        //    this.whichComp = 'DevActionLineItemGroup'
        location.href = "/developer/app/action/input/line-item";
      }
    },

    editPage(index) {
      this.addBox = !this.addBox;
      this.$store.state.devStore.apiSchema =
        this.inputLists[index];

      console.log(this.inputLists[index].checkType);

      if (this.inputLists[index].checkType.includes("field")) {
        this.$store.state.devStore.reMenu = index;
        this.typeOfBtn = "field";
        this.whichComp = "DevActionInputFormField";
        this.toForm = true;
        this.containTable = false;
      } else if (this.inputLists[index].checkType.includes("dynamic")) {
        this.$store.state.devStore.reMenu = index;

        this.toDynamic();
      } else if (this.inputLists[index].checkType.includes("lineGroup")) {
        this.$store.state.devStore.reMenu = index;

        this.toLineGroup();
      }
    },
    deletePage(index) {
      if(confirm('삭제하시겠습니까?')){
        var param = {
          apiCode: this.$store.state.devStore.apiCode,
          where: "input",
          count: index,
        };


          this.api.deleteApiSchema(param)
          .then((res) => {
            console.log("결과 : ", res);
                this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
                    .then((res)=>{
                      this.$store.dispatch("apiDetail", {result : res}).then(() => {
                        this.inputLists = this.$store.state.devStore.formsData;
                      });

                    })

          })
          .catch(() => alert("오류가 발생했습니다. > 액션 필드 부분"));

      }
    },

    checkTyper() {
      if (this.inputLists != null) {
        if (this.inputLists[0].checkType.replace(/"/gi, "") == "field") {
          console.log("field임");

          this.toForm = true;
          this.containTable = false;
          this.typeOfBtn = "field";
          this.whichComp = "DevActionInputFormField";
          this.$store.state.devStore.reMenu = this.inputLists.length;
        } else if (
          this.inputLists[0].checkType.replace(/"/gi, "") == "dynamic"
        ) {
          console.log("field임");

          this.toDynamic();
        } else if (
          this.inputLists[0].checkType.replace(/"/gi, "") == "lineGroup"
        ) {
          console.log("field임");
          this.$store.state.devStore.reMenu = this.inputLists.length;

          this.toLineGroup();
        }
      }
    },

    cancelAlert() {
      this.inputLists = this.$store.state.devStore.formsData;

      this.toForm = !this.toForm;
      this.addBox = !this.addBox;

      if (this.inputLists != null) {
        this.inputTopBtns = false;
        this.containTable = true;
      } else {
        this.inputTopBtns = true;
        this.containTable = false;
      }
      this.whichComp = "";
    },
    toDynamicMain() {
      this.$store.state.devStore.reMenu = this.inputLists.length;
      this.toDynamic();
    },
    toDynamic() {
      // this.$store.state.devStore.reMenu = this.inputLists.length
      this.typeOfBtn = "dynamic";
      this.$router.push({
        name: "DevActInputDynamic",
        params: { appId: this.$route.params.appId },
      });
    },
    toLineGroupMain() {
      this.$store.state.devStore.reMenu = this.inputLists.length;

      this.$store.state.devStore.apiSchema = null;
      this.toLineGroup();
    },
    toLineGroup() {


      this.typeOfBtn = "lineGroup";
      this.$router.push({
        name: "DevActInputLineGroup",
        params: { appId: this.$route.params.appId },
      });
    },
    removeEmojy(value) {
      console.log(value != "null");
      if (value != "null") {
        return value.replace(/"/gi, "");
      } else {
        return "-";
      }
    },
    checkInputType(type) {
      console.log("타입 체크 :", type);

      if (type.includes("field")) {
        return "필드";
      } else if (type.includes("dynamic")) {
        return "다이나믹";
      } else if (type.includes("line")) {
        return "아이템그룹";
      }
    },
  },

  data() {
    return {
      typeOfBtn: null,
      inputLists: null,

      whichComp: "",
      inputTopBtns: false,
      containTable: false,
      toForm: false,

      addBox: true,
    };
  },

  mounted() {
    console.log("mounted ...");
    console.log(this.toMain);
  },
  created() {
    console.log("created ...", this.$store.state.devStore.formsData);
    this.inputLists = null;

    this.$store.state.devStore.apiSchema = null;

    this.inputLists = this.$store.state.devStore.formsData;
    // this.inputLists = this.$store.state.devStore.apiSchema

    if (this.$store.state.devStore.formsData.length > 0) {
      this.containTable = true;
      //     this.inputTopBtns = false
    } else {
      //     this.inputLists = null
      this.containTable = false;
      //     this.inputTopBtns = true
    }


    this.$store.state.devStore.reMenu = this.$store.state.devStore.formsData.length
    console.log( this.$store.state.devStore.reMenu )

    console.log("forms data 값: ", this.$store.state.devStore.formsData);
  },
};
</script>
